import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { HeartIcon } from '../../Images/svgs'

function OurProjects() {
    const feed = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    return (
        <div className="flex flex-col">
            <div className="self-star text-3xl font-bold whitespace-nowrap text-zinc-900">
                مشاريعنا في فلسطين
            </div>
            <div className="mt-8 w-full max-md:max-w-full">
                <div className="flex max-md:flex-col max-md:gap-0 max-md:">
                    {feed.filter((item, index) => index < 4).map((filteredItem, index) => (
                        <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full last:ml-0">
                            <div className="flex flex-col grow p-2 mx-auto w-full bg-white rounded-lg border border-solid border-zinc-300 max-md:mt-5">
                                <div className="flex overflow-hidden relative flex-col justify-between px-3 pt-3 pb-12 w-full text-sm font-medium tracking-normal leading-3 text-center text-emerald-900 uppercase whitespace-nowrap rounded-md aspect-[1.34]">
                                    <LazyLoadImage
                                        src="https://s3-alpha-sig.figma.com/img/470e/e056/3af5b086eb5997b3609bdd162d6a27e8?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Y7ff9RI9eTGAkCuuaLr9dyajKKlE3miIuRNLmu-Wh1taaAxg~kn1tOVVcW0ARN~qP73BlxuYhwcfWppCqvxRg6~2t1lNQtgb4qpaOQLEGIi9YyNKTrICUUbRjgMG5LaoMFxm7jbqkapx6Zj1Xk14fyx7B5Vn8oIsZpcI4VguD~t-j4fdnBjJY7RtGi55G2HyANyXEmPDprN3X2CDtgVW6heJe8RWztes73369yJyODiW3~-FmKVN2cKpv5k3mG8cSCVN1HYljxCnJpzPGNN~c8z9mKMxI0lnPCXgGrzovgBBqHLSV2txzbFJOPmeE2VWF5d1w-hAB1JEUPnxrCXLAQ__"
                                        className="object-cover absolute inset-0 size-full"
                                    />
                                    <div className="flex relative gap-5 justify-between mb-20 max-md:mb-10">
                                        <div className="justify-center px-2.5 py-1 my-auto bg-emerald-100 rounded-xl border-emerald-900 border-solid border-[0.5px]">
                                            بيوت فقراء
                                        </div>
                                        <HeartIcon
                                            className="w-6 aspect-square"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-col p-2 mt-1">
                                    <div className="text-xl font-bold text-right text-zinc-900">
                                        الحالة &quot;2&quot; دعم قصص النجاح في غزة
                                    </div>
                                    <div className="self-star mt-3 text-sm text-right whitespace-nowrap text-stone-900">
                                        آخر تبرع قبل ساعتين
                                    </div>
                                    <div className="flex flex-col justify-center items-end pl-16 mt-2 bg-gray-200 rounded max-md:pl-5">
                                        <div className="h-2 rounded w-[138px] bg-blue-800 self-start" />
                                    </div>
                                    <div className="flex gap-5 justify-between mt-3 text-right text-stone-900">
                                        <div className="text-base font-bold">66,200$ دولار </div>
                                        <div className="text-sm">$100,000 دولار</div>
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-between mt-1">
                                    <div className="flex gap-5 justify-between p-1 whitespace-nowrap bg-white rounded-lg border border-solid border-[color:var(--Gray-300,#D0D5DD)]">
                                        <div className="my-auto text-base leading-6 text-right text-gray-500">
                                            القيمة
                                        </div>
                                        <div className="justify-center px-3.5 py-2 text-sm font-semibold leading-5 text-white bg-blue-600 rounded-lg border border-blue-500 border-solid shadow-sm aspect-[1.39]">
                                            تبرع
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center px-3.5 py-3 bg-white rounded-lg border border-solid shadow-sm aspect-[1.11] border-[color:var(--Gray-300,#D0D5DD)]">
                                        <LazyLoadImage
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6265d617e60ca7f9d2580aadff04c29f8aba4c74fae6832dc132b54afa4b3a44?"
                                            className="aspect-[1.05] w-[21px]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default OurProjects